import request from '@/CommonDP/utils/request';
// 字体样式维护
export default {
  // 列表
  selectStandardFontMaintenance(enterpriseId) {
    return request.get(
      `/standardFontMaintenanceService/selectStandardFontMaintenance?enterpriseId=${enterpriseId}`
    );
  },
  // 修改
  updateStandardFont(params) {
    return request
      .post(`/standardFontMaintenanceService/updateStandardFont`, params)
      .then((res) => res);
  },
  // 删除
  deleteStandardFont(params) {
    return request.get(
      '/standardFontMaintenanceService/deleteStandardFont',
      {
        params
      }
    );
  },
  // 上传
  uploadStandardFontFile(data) {
    return request.post(
      '/standardFontMaintenanceService/uploadStandardFontFile',
      data,
      { timeout: 0 }
    );
  },
  // 下载
  downloadStandardFontFile(fileID) {
    return request({
      url: `/standardFontMaintenanceService/downloadStandardFontFile/download/${fileID}`,
      method: 'get',
      responseType: 'blob'
    });
  }
};
